module.exports = __webpack_public_path__ + "assets/logo.7093915c.svg";